<template>
    <a-popover
        placement="bottomLeft"
        trigger="click"
        :overlayClassName="`${popoverClass} modern-select-popover`"
        v-model="popoverVisible"
    >
        <template slot="content">
            <div class="modern-select-dropdown">
                <div class="select-header" v-if="showHeader">
                    <span class="select-title">{{ headerTitle }}</span>
                </div>
                <div class="select-search" v-if="enableSearch">
                    <input type="text" v-model="searchQuery" :placeholder="searchPlaceholder" class="search-input" />
                </div>
                <div class="select-options">
                    <a-tooltip 
                        v-for="opt in processedOptions.ungrouped"
                        :key="opt.value"
                        placement="right"
                        :title="opt.fullLabel || opt.label"
                    >
                        <div
                            class="select-option"
                            :class="{
                                active: multiple
                                    ? Array.isArray(internalValue) && internalValue.includes(opt.value)
                                    : internalValue === opt.value &&
                                      internalValue !== '' &&
                                      internalValue !== null &&
                                      internalValue !== undefined,
                            }"
                            @click="onSelect(opt.value)"
                        >
                            <div class="option-content">
                                <component
                                    v-if="opt.iconType === 'component'"
                                    :is="opt.icon"
                                    :class="{ 'option-icon-component': true, [opt.icon]: true }"
                                />
                                <i v-else-if="opt.icon" class="material-icons option-icon">{{ opt.icon }}</i>
                                <span class="option-label">{{ opt.label }}</span>
                            </div>
                            <i
                                v-if="
                                    multiple
                                        ? Array.isArray(internalValue) && internalValue.includes(opt.value)
                                        : internalValue === opt.value &&
                                          internalValue !== '' &&
                                          internalValue !== null &&
                                          internalValue !== undefined
                                "
                                class="material-icons check-icon"
                                >{{ checkIcon }}</i
                            >
                        </div>
                    </a-tooltip>

                    <template v-for="group in processedOptions.groups">
                        <div class="group-header" :key="`header-${group.name}`">
                            {{ group.name }}
                        </div>
                        <a-tooltip
                            v-for="opt in group.items"
                            :key="opt.value"
                            placement="right"
                            :title="opt.fullLabel || opt.label"
                        >
                            <div
                                class="select-option"
                                :class="{
                                    active: multiple
                                        ? Array.isArray(internalValue) && internalValue.includes(opt.value)
                                        : internalValue === opt.value &&
                                          internalValue !== '' &&
                                          internalValue !== null &&
                                          internalValue !== undefined,
                                }"
                                @click="onSelect(opt.value)"
                            >
                                <div class="option-content">
                                    <component
                                        v-if="opt.iconType === 'component'"
                                        :is="opt.icon"
                                        :class="{ 'option-icon-component': true, [opt.icon]: true }"
                                    />
                                    <i v-else-if="opt.icon" class="material-icons option-icon">{{ opt.icon }}</i>
                                    <span class="option-label">{{ opt.label }}</span>
                                </div>
                                <i
                                    v-if="
                                        multiple
                                            ? Array.isArray(internalValue) && internalValue.includes(opt.value)
                                            : internalValue === opt.value &&
                                              internalValue !== '' &&
                                              internalValue !== null &&
                                              internalValue !== undefined
                                    "
                                    class="material-icons check-icon"
                                    >{{ checkIcon }}</i
                                >
                            </div>
                        </a-tooltip>
                    </template>
                </div>
            </div>
        </template>

        <div class="modern-select-trigger" :class="triggerClass">
            <slot name="trigger">
                <div class="select-button" :class="buttonClass">
                    <i v-if="showIcon && currentIcon" class="material-icons button-icon">{{ currentIcon }}</i>
                    <span class="button-text-v2">{{ currentLabel }}</span>
                    <i v-if="removable" class="material-icons chip-remove-inline" @click.stop="onRemoveClick">close</i>
                    <i v-if="clearable && !removable" class="material-icons chip-clear-inline" @click.stop="onClearClick">delete_forever</i>
                    <i v-if="showDropdownArrow" class="material-icons dropdown-arrow">keyboard_arrow_down</i>
                </div>
            </slot>
        </div>
    </a-popover>
</template>

<script>
import SupsisIcon from "@/views/Pages/Chatbot/pages/integrations/svg/SupsisIcon";
import WhatsappBusinessIcon from "@/views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import WhatsappV2 from "@/views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import InstagramIcon from "@/views/Pages/Chatbot/pages/integrations/svg/InstagramIcon";
import FacebookIcon from "@/views/Pages/Chatbot/pages/integrations/svg/FacebookIcon.vue";
import TelegramIcon from "@/views/Pages/Chatbot/pages/integrations/svg/TelegramIcon";
import LinkedinIcon from "@/views/Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";
import WhatsappV3Icon from "@/views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";

export default {
    name: "MinimalPopoverSelect",
    components: {
        SupsisIcon,
        WhatsappBusinessIcon,
        WhatsappV2,
        InstagramIcon,
        FacebookIcon,
        TelegramIcon,
        LinkedinIcon,
        WhatsappV3Icon,
    },
    props: {
        value: {
            type: [String, Array, Boolean, Number, Object],
            default: "",
        },
        valueText: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: function () {
                return [];
            },
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        triggerClass: {
            type: String,
            default: "",
        },
        buttonClass: {
            type: String,
            default: "",
        },
        popoverClass: {
            type: String,
            default: "modern-select-popover",
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        showDropdownArrow: {
            type: Boolean,
            default: true,
        },
        filterName: {
            type: String,
            default: "",
        },
        showHeader: {
            type: Boolean,
            default: false,
        },
        enableSearch: {
            type: Boolean,
            default: false,
        },
        headerTitle: {
            type: String,
            default: "Arama Alanı",
        },
        checkIcon: {
            type: String,
            default: "check_circle",
        },
        defaultIcon: {
            type: String,
            default: null,
        },
        searchPlaceholder: {
            type: String,
            default: "Filtre ara...",
        },
        removable: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            internalValue: this.multiple ? (Array.isArray(this.value) ? this.value : []) : this.value,
            popoverVisible: false,
            searchQuery: "",
        };
    },
    watch: {
        value: {
            handler(val) {
                this.internalValue = this.multiple ? (Array.isArray(val) ? val : []) : val;
            },
            deep: true,
        },
        popoverVisible: {
            handler(val) {
                if (!val) {
                    this.searchQuery = "";
                }
            },
        },
    },
    computed: {
        filteredOptions: function () {
            let options = this.options;

            // Önce arama filtrelemesi yap
            if (this.searchQuery) {
                options = options.filter((opt) => opt.label.toLowerCase().includes(this.searchQuery.toLowerCase()));
            }

            return options;
        },
        processedOptions: function () {
            const ungrouped = [];
            const grouped = {};

            this.filteredOptions.forEach((opt) => {
                if (opt.group) {
                    if (!grouped[opt.group]) {
                        grouped[opt.group] = [];
                    }
                    grouped[opt.group].push(opt);
                } else {
                    ungrouped.push(opt);
                }
            });

            const groups = Object.keys(grouped).map((groupName) => ({
                name: groupName,
                items: grouped[groupName],
            }));

            return {
                ungrouped: ungrouped,
                groups: groups,
            };
        },
        currentIcon: function () {
            return this.options.filter((opt) => opt.value === this.internalValue)?.[0]?.icon || this.defaultIcon;
        },
        currentLabel: function () {
            if (this.valueText) {
                return this.filterName ? `${this.filterName}: ${this.valueText}` : this.valueText;
            }
            var prefix = this.filterName ? this.filterName + ": " : "";

            if (this.multiple) {
                if (!Array.isArray(this.internalValue) || this.internalValue.length === 0) {
                    return this.filterName || "Seçin";
                }
                if (this.internalValue.length === 1) {
                    var found = this.options.find((opt) => opt.value === this.internalValue[0]);
                    var label = found ? found.label : "Seçin";
                    return prefix + label;
                }
                var firstFound = this.options.find((opt) => opt.value === this.internalValue[0]);
                var firstLabel = firstFound ? firstFound.label : this.internalValue[0];
                return prefix + firstLabel + " (+" + (this.internalValue.length - 1) + ")";
            } else {
                if (this.internalValue === undefined || this.internalValue === null) {
                    return this.filterName || "Seçin";
                }
                var found = null;
                for (var i = 0; i < this.options.length; i++) {
                    if (this.options[i].value === this.internalValue) {
                        found = this.options[i];
                        break;
                    }
                }
                var label = found ? found.label : "Seçin";
                return prefix + label;
            }
        },
    },
    methods: {
        onSelect: function (val) {
            if (this.multiple) {
                var newValue = Array.isArray(this.internalValue) ? [...this.internalValue] : [];
                var index = newValue.indexOf(val);
                if (index > -1) {
                    newValue.splice(index, 1);
                } else {
                    newValue.push(val);
                }
                this.internalValue = newValue;
                this.$emit("input", newValue);
                this.$emit("change", newValue);
                // Multiple'da popover'ı kapatmıyoruz, kullanıcı birden fazla seçim yapabilsin
            } else {
                this.internalValue = val;
                this.popoverVisible = false; // Single'da popover'ı kapat
                this.$emit("input", val);
                this.$emit("change", val);
            }
        },
        openPopover: function () {
            this.popoverVisible = true;
        },
        closePopover: function () {
            this.popoverVisible = false;
        },
        onRemoveClick: function () {
            this.$emit("remove-click");
        },
        onClearClick: function () {
            this.$emit("clear-click");
        },
    },
};
</script>

<style scoped lang="scss">
.modern-select-trigger {
    display: inline-flex;
    white-space: nowrap;
    width: 100%;
    min-width: 0;
}

.select-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    transition: all 0.15s ease;
    width: 100%;
    min-width: 0;

    &:hover {
        border-color: #22272d;
        background: #f8f9fa;
    }
}

.button-icon {
    font-size: 18px;
    color: #6b7785;
}

.button-icon-component {
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.button-text-v2 {
    flex: 1;
    font-size: 11px !important;
    font-weight: 600;
    color: #22272d;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 40px;
}

.chip-remove-inline,
.chip-clear-inline {
    font-size: 16px;
    color: #9ca3af;
    cursor: pointer;
    padding: 2px;
    border-radius: 50%;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    line-height: 1;
    margin-left: 4px;

    &:hover {
        color: #dc3545;
        background: rgba(220, 53, 69, 0.1);
        transform: scale(1.15);
    }
}

.dropdown-arrow {
    font-size: 18px;
    color: #6b7785;
    transition: transform 0.2s ease;
}

.select-search {
    padding: 8px 12px;
    border-bottom: 1px solid #e0e0e0;

    .search-input {
        width: 100%;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        padding: 6px 10px;
        font-size: 13px;
        outline: none;

        &:focus {
            border-color: #22272d;
        }

        &::placeholder {
            color: #bfbfbf;
        }
    }
}
</style>

<style lang="scss">
/* Global popover overrides rendered under body */
.modern-select-popover {
    margin-top: -8px;

    .ant-popover-arrow {
        display: none;
    }

    .ant-popover-inner-content {
        padding: 4px 0;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        overflow: hidden;
    }

    .modern-select-dropdown {
        min-width: 180px;
        background: #fff;
    }

    .select-header {
        display: none;
    }

    .select-options {
        padding: 0;
        max-height: 300px;
        overflow-y: auto;
    }

    .select-option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        cursor: pointer;
        color: #22272d;
        transition: all 0.15s ease;

        &:hover {
            background: #f5f5f5;
        }

        &.active {
            background: #f0f0f0;
            color: #22272d;
            font-weight: 600;

            .option-icon {
                color: #22272d;
            }
        }

        &.option-disabled {
            cursor: default;

            &:hover {
                background: transparent;
            }
        }
    }

    .select-option .option-content {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
    }

    .select-option .option-icon {
        font-size: 16px;
        color: #6b7785;
        transition: color 0.15s ease;
    }

    .select-option .option-icon-component {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &.WhatsappBusinessIcon path {
            stroke: #59c864;
        }

        &.WhatsappV2 path {
            fill: #59c864;
        }

        &.WhatsappV3Icon path {
            fill: #59c864;
        }

        &.InstagramIcon path {
            fill: #d6249f;
        }
    }

    .select-option .option-label {
        font-size: 13px;
        font-weight: 500;
    }

    .select-option .check-icon {
        font-size: 16px;
        color: #22272d;
    }

    .group-header {
        color: #374151;
        font-weight: 400;
        font-size: 13px;
        padding: 0px 12px 0px 12px;
        margin: 8px 0 4px 0;
        cursor: default;
    }
}

// Trigger hover state for dropdown arrow rotation
.modern-select-popover.ant-popover-open .modern-select-trigger .dropdown-arrow {
    transform: rotate(180deg);
}

// Oval chip style for GridContactListToolbar
.modern-select-trigger .chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 5px 20px;
    border: 1px solid #c7d0d7;
    border-radius: 999px;
    background: #fff;
    color: #22272d;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;

    &:hover {
        background: #f0f0f0;
    }

    strong {
        font-weight: 700;
    }

    .material-icons {
        font-size: 18px;
        line-height: 1;
        color: #22272d;
    }
}
</style>
